<template>
  <div>
    <b-tabs
      content-class="v-tab-content"
      active-nav-item-class="v-tab-active"
      small
    >
      <b-tab title="RESUMO">
        <SubTabResumoFinanceiroSintetico :wbs="wbs" :acao="acao" v-if="sintetico" />
        <SubTabResumoFinanceiro :wbs="wbs" :acao="acao" v-else />
      </b-tab>
      <b-tab title="Medições">
        <SubTabMedicoes :wbs="wbs" :acao="acao" :sintetico="sintetico" />
      </b-tab>

      <b-tab title="Pagamentos">
        <SubTabPagamentos :wbs="wbs" :acao="acao" :sintetico="sintetico" />
      </b-tab>
      <b-tab title="Reconhecimentos">
        <SubTabReconhecimentos :wbs="wbs" :acao="acao" :sintetico="sintetico" />
      </b-tab>
      <!-- <b-tab title="Desembolsos">
        <SubTabDesembolsos :wbs="wbs" :acao="acao" :sintetico="sintetico" />
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
//import SubTabDesembolsos from "./SubTabDesembolsos.vue";
import SubTabResumoFinanceiro from "./SubTabResumoFinanceiro.vue";
import SubTabPagamentos from "./SubTabPagamentos.vue";
import SubTabReconhecimentos from "./SubTabReconhecimentos.vue";
import SubTabMedicoes from "./SubTabMedicoes.vue";
import SubTabResumoFinanceiroSintetico from "./SubTabResumoFinanceiroSintetico.vue";

export default {
  name: "TabFinanceiro",
  components: {
    SubTabResumoFinanceiro,
    SubTabPagamentos,
    SubTabMedicoes,
    SubTabReconhecimentos,
    SubTabResumoFinanceiroSintetico
  },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true },
    sintetico: { type: Boolean, required: true },
  },
};
</script>

<style scoped>
.v-tab-active {
  background-color: #0067d6 !important;
  color: white !important;
}

.nav-tabs .nav-link {
  border-color: #ddd !important;
}

.v-tab-content {
  border: 1px solid #ddd;
  padding: 10px;
  box-shadow: 1px 1px 5px 0 #ccc;
}

.nav-tabs .nav-link:hover {
  background-color: #ddd !important;
  color: #333 !important;
}
</style>
